module.exports = __webpack_public_path__ + "img/factory02.a65d29bb.jpg";